import { TRANSITION_DURATION } from '@constants/common'
import clsx from 'clsx'
import { motion } from 'motion/react'

import s from './MotionWrapper.module.scss'
import type { MotionWrapperProps } from './MotionWrapper.props'

export function MotionWrapper({ children, withIndent = true, ref, className }: MotionWrapperProps) {
  return (
    <motion.div
      ref={ref}
      initial={{ gridTemplateRows: '0fr', opacity: 0, y: 15 }}
      animate={{ gridTemplateRows: '1fr', opacity: 1, y: 0 }}
      exit={{ gridTemplateRows: '0fr', opacity: 0, y: 15 }}
      transition={{ duration: TRANSITION_DURATION }}
      className={clsx(s.wrapper, className)}
    >
      <div className={s.overflow}>
        {children}

        {withIndent && <div className={s.indent} />}
      </div>
    </motion.div>
  )
}
